import { render, staticRenderFns } from "./NgoaiNguForm.vue?vue&type=template&id=cff97682&"
import script from "./NgoaiNguForm.vue?vue&type=script&lang=js&"
export * from "./NgoaiNguForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports